import React from "react";
// UI
import useBookingPanelStyles from "styles/useBookingPanelStyles";
import WarningAlert from "core/alerts/WarningAlert";
import clsx from "clsx";

export default function BookingCTAs({booking, handleAction}) {
  const classes = useBookingPanelStyles();
  const bookingActions = booking?.actions?.booking_actions || [];

  const handleActionClick = (props, type) => () => handleAction(props, type);

  return (
    <div className={clsx(classes.col, "-md-space")}>
      {bookingActions.map((props, index) => (
        <WarningAlert
          key={`bkg_action_${index}`}
          hide={false}
          disableMargin
          action={handleActionClick(props, "confirm")}
          actionButtonLabel={props.confirm?.label}
          secondaryAction={handleActionClick(props, "deny")}
          secondaryActionLabel={props.deny?.label}
          title={props.label}
        />
      ))}
    </div>
  );
}
